// src/components/Toolbar/ViewControls/ViewControls.tsx
import React from 'react';
import { Grid3X3, ZoomIn, ZoomOut } from 'lucide-react';
import { useUiStateStore } from '@/stores/uiStateStore';

export const ViewControls: React.FC = () => {
  const uiStateActions = useUiStateStore((state) => state.actions);
  const zoom = useUiStateStore((state) => state.zoom);
  const showGrid = useUiStateStore((state) => state.showGrid);

  const handleZoomIn = () => {
    uiStateActions.incrementZoom();
  };

  const handleZoomOut = () => {
    uiStateActions.decrementZoom();
  };

  const handleGridToggle = () => {
    uiStateActions.setShowGrid(!showGrid);
  };

  return (
    <div className="flex items-center gap-2">
      {/* Grid Toggle */}
      <button
        type="button"
        onClick={handleGridToggle}
        className={`relative flex h-8 w-8 items-center justify-center rounded-md border transition-colors ${
          showGrid
            ? 'border-blue-300 bg-blue-50 text-blue-600 dark:border-blue-600 dark:bg-blue-950 dark:text-blue-400'
            : 'border-gray-300 bg-white text-gray-600 hover:bg-gray-50 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-400 dark:hover:bg-slate-700'
        }`}
        title={showGrid ? 'Hide Grid' : 'Show Grid'}
        aria-label={showGrid ? 'Hide grid' : 'Show grid'}
        aria-pressed={showGrid}
      >
        <Grid3X3 size={16} />
        {/* Diagonal line when grid is hidden */}
        {!showGrid && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="h-px w-6 rotate-45 bg-current" />
          </div>
        )}
      </button>

      {/* Zoom Controls */}
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={handleZoomOut}
          className="flex h-8 w-8 items-center justify-center rounded-md border border-gray-300 bg-white text-gray-600 transition-colors hover:bg-gray-50 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-400 dark:hover:bg-slate-700"
          title="Zoom Out"
          aria-label="Zoom out"
        >
          <ZoomOut size={16} />
        </button>
        <span className="min-w-[3.5rem] text-center text-sm text-gray-600 dark:text-gray-300">
          {Math.round(zoom * 100)}%
        </span>
        <button
          type="button"
          onClick={handleZoomIn}
          className="flex h-8 w-8 items-center justify-center rounded-md border border-gray-300 bg-white text-gray-600 transition-colors hover:bg-gray-50 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-400 dark:hover:bg-slate-700"
          title="Zoom In"
          aria-label="Zoom in"
        >
          <ZoomIn size={16} />
        </button>
      </div>

      {/* Share Button */}
      {/* <button
        className="flex h-8 w-8 items-center justify-center rounded-md border border-gray-300 bg-white text-gray-600 transition-colors hover:bg-gray-50 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-400 dark:hover:bg-slate-700"
        title="Share"
      >
        <Share size={16} />
      </button> */}
    </div>
  );
};
